import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MultiSelectorComponent } from "@components/multi-selector/multi-selector.component";
import { of } from "rxjs";
import { BYL } from "~app/common/models/constants";
import { IGetArbetsorderRequest } from "~app/features/planera/model/IGetArbetsorderRequest";

@Component({
    selector: "rask-byl",
    templateUrl: "./byl.component.html",
    styleUrls: ["./byl.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MultiSelectorComponent,
        FormsModule
    ]
})
export class BylComponent {
    @Input() searchFilter: IGetArbetsorderRequest;

    protected barighetItems = of(BYL.barighetItems);
    protected ytstrukturItems = of(BYL.ytstrukturItems);
    protected lutningItems = of(BYL.lutningItems);
}
